const MOJIBAKE_REPLACEMENTS: ReadonlyArray<readonly [string, string]> = [
  ['├í', 'á'],
  ['├⌐', 'é'],
  ['├®', 'é'],
  ['├¡', 'í'],
  ['├│', 'ó'],
  ['├║', 'ú'],
  ['├╝', 'ü'],
  ['├▒', 'ñ'],
  ['├ü', 'Á'],
  ['├ë', 'É'],
  ['├ì', 'Í'],
  ['├ô', 'Ó'],
  ['├Ü', 'Ú'],
  ['├£', 'Ü'],
  ['├æ', 'Ñ'],
  ['┬í', '¡'],
  ['┬┐', '¿'],
  ['┬┤', '´'],
  ['├º', 'ç'],
  ['├ç', 'Ç'],
  ['Ã¡', 'á'],
  ['Ã©', 'é'],
  ['Ã­', 'í'],
  ['Ã³', 'ó'],
  ['Ãº', 'ú'],
  ['Ã¼', 'ü'],
  ['Ã±', 'ñ'],
  ['Ã\u0081', 'Á'],
  ['Ã\u0089', 'É'],
  ['Ã\u008D', 'Í'],
  ['Ã\u0093', 'Ó'],
  ['Ã\u009A', 'Ú'],
  ['Ã\u009C', 'Ü'],
  ['Ã\u0091', 'Ñ'],
  ['Ã‰', 'É'],
  ['Ã“', 'Ó'],
  ['Ãš', 'Ú'],
  ['Ãœ', 'Ü'],
  ['Ã‘', 'Ñ'],
  ['Â¡', '¡'],
  ['Â¿', '¿'],
  ['Ã§', 'ç'],
  ['Ã‡', 'Ç']
];

export function repairTextEncoding(value: string): string {
  let repaired = value;
  for (let pass = 0; pass < 3; pass += 1) {
    const previous = repaired;
    for (const [broken, correct] of MOJIBAKE_REPLACEMENTS) {
      repaired = repaired.split(broken).join(correct);
    }
    if (repaired === previous) break;
  }
  return repaired.normalize('NFC');
}
